import React from 'react';
import { Link, useI18next, useTranslation } from 'gatsby-plugin-react-i18next';

import targetLogoSmall from '@icons/targetLogoSmall';
import connectLogoSmall from '@icons/connectLogoSmall';
import datacareLogoSmall from '@icons/datacareLogoSmall';
import leadfeederLogoSmall from '@icons/leadfeederLogoSmall';

import * as styles from './style.module.scss';

const {
  sublink,
  sublinkHighlighted,
  sublinkGrid,
  sublinkNoBorder,
  itemIcon,
  sublabel,
  subcaption,
  newLabel,
  itemLogo,
} = styles;

export const SubGroupItem = ({
  href,
  lang,
  highlighted,
  grid,
  logos,
  leadfeederLogo,
  icon,
  label,
  caption,
  mobOrder,
  spacer=false,
  iconLink=false,
}) => {
  const { language } = useI18next();
  const { t } = useTranslation();

  const isNewResource = [
    '/resources/newsletters',
    '/resources/stream',
    '/resources/playbooks',
    '/resources/the-sales-stoic',
    '/resources/press-releases',
    '/platform/features/ai-insights/',
  ].includes(href);

  const isComingSoon = href === '/resources/reports';
  const isExternal = href?.startsWith('http');

  return (
    iconLink ? iconLink : (
      isExternal ? (
        <a
          href={href}
          className={`${sublink} order-${mobOrder} ${highlighted ? sublinkHighlighted : ''} ${spacer ? sublinkNoBorder : ''} ${grid ? sublinkGrid : ''}`}
        >
          {logos && (
            <div className={itemLogo}>
              {targetLogoSmall}
              {connectLogoSmall}
              {datacareLogoSmall}
            </div>
          )}

          {leadfeederLogo && <span>{leadfeederLogoSmall}</span>}

          {icon && href !== '/careers' && (
            <span className={itemIcon}>
              {typeof icon === 'string' ? (
                <img src={icon} alt={label} />
              ) : (
                icon
              )}
            </span>
          )}

          <p className={sublabel}>
            {label}
            {isNewResource && <span className={newLabel}>{t('nav_new')}</span>}
            {isComingSoon && (
              <span className={newLabel}>{t('nav_coming_soon')}</span>
            )}
          </p>

          <p className={subcaption} dangerouslySetInnerHTML={{ __html: caption }} />
        </a>
      ) : (
        <Link
          language={lang || language}
          to={href}
          className={`${sublink} order-${mobOrder} ${highlighted ? sublinkHighlighted : ''} ${spacer ? sublinkNoBorder : ''} ${grid ? sublinkGrid : ''}`}
        >
          {logos && (
            <div className={itemLogo}>
              {targetLogoSmall}
              {connectLogoSmall}
              {datacareLogoSmall}
            </div>
          )}

          {leadfeederLogo && <span>{leadfeederLogoSmall}</span>}

          {icon && href !== '/careers' && (
            <span className={itemIcon}>
              {typeof icon === 'string' ? (
                <img src={icon} alt={label} />
              ) : (
                icon
              )}
            </span>
          )}

          <p className={sublabel}>
            {label}
            {isNewResource && <span className={newLabel}>{t('nav_new')}</span>}
            {isComingSoon && (
              <span className={newLabel}>{t('nav_coming_soon')}</span>
            )}
          </p>

          <p className={subcaption} dangerouslySetInnerHTML={{ __html: caption }} />
        </Link>
      )
    )
  );
};
